<template
  ><!-- 23:疯狂捉娃娃 24:大家来找茬 -->
  <div class="createPlayStep new-input-box">
    <!-- 头部返回 -->
    <div class="backBox">
      <!-- <img class="pointer" @click="returnBack()" src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/back.svg" alt="" /> -->
      <jd-button type="blue" :styleTextObj="{width:'44px',height: '24px','line-height': '24px',padding: '0 8px','min-width': '44px'}" @click="returnBack()">返回</jd-button>
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStep != 99 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStep == 99">
        <div class="activeEdit_bottom" v-loading="loading">
          <div class="template">
            <div style="width: 82px;padding-top: 5px;">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == 0 }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div class="temImg_content" @click="handleOpen()" style="border: 1px solid #D4E2FF;">
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div class="temImg_content_wz" style="background: #EAF1FF;"></div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow" style="height:432px;border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow_codeDZ">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img style="width:100%;max-height: 380px;" :src="item.templateUrl" alt="" />
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.title }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div class="temImg_content_bgshadow_code qrCodeIMG" id="qrCodeIMG1" ref="qrCodeIMG1"></div>
                <div class="temImg_content_bgshadow_codeDesc">手机扫码预览模板</div>
                <div class="temImg_content_bgshadow_btn pointer" @click="nextStepKai(item, 2)">使用此模板</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep" v-if="localStep != 99">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="backgroundForm" label-width="135px">
          <informationForm
            v-model="ruleForm"
            @selectPeopleSure="selectPeopleSure" 
            :defaultActMember.sync="actMember" 
            :defaultActivityStartTime.sync="ruleForm.activityStartTime" 
            :defaultActivityEndTime.sync="ruleForm.activityEndTime" 
            :plusObject.sync="ruleDto.plusObject" 
            :isCheckOpenCardTime.sync="ruleDto.isCheckOpenCardTime" 
            :openCardStartTime.sync="ruleDto.openCardStartTime" 
            :openCardEndTime.sync="ruleDto.openCardEndTime" 
            :peopleSelected.sync="peopleSelected"
            :disabled="isStart" 
            :localStepNum="localStepNum" 
            :isShowCondFollow="false"
            :isShowBlack="true"
            needNonMember
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          />
          <!-- <jd-title label='基本信息' type="bold"></jd-title>
          <el-form-item label="活动名称:" required>
            <el-input v-model="ruleForm.activityName" :disabled="isStart" maxlength="15" show-word-limit placeholder="请填入活动名称" style="width: 400px"></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.activityStartTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                :clearable="false"
                :disabled="isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.activityEndTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                @focus="orderFocus"
                :picker-options="pickerOptionsValueEnd"
                :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                :clearable="false"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" v-if="!isStart" @click="clearTime(2)"></i>
              <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天 <span style="color: #fe4d45">{{ timeOut }}</span> 小时
              <el-tooltip class="item" effect="light" content="活动时间不可超过互动数据授权有效期及店铺接入有效期" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
            <div class="act-tip" v-if="isShowTip">
              *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
            </div>
          </el-form-item>
          <el-form-item label="活动对象:" prop="partner">
            <el-radio v-model="actMember" label="1" :disabled="isStart">不限</el-radio>
            <el-radio v-model="actMember" label="2" :disabled="isStart">会员身份</el-radio>
            <el-radio v-model="actMember" label="3" :disabled="isStart || softType == 1">指定人群
              <el-button style="margin-left:10px;" v-if="actMember == '3'" :disabled="isStart" @click="openCrowd">已选人群({{peopleSelected.length}})</el-button>
            </el-radio>

            <div v-if="actMember == '2'" style="display:flex">
                <span>会员等级：</span>
            <el-checkbox-group v-model="ruleForm.partner" @change="checkListchange" :disabled="isStart" v-if="actMember == '2'">
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox label="0" name="partner" :disabled="ruleForm.partner == -1">非会员</el-checkbox>
              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
            </div>
            <div v-if="actMember == '2'" style="display:flex">
              <span>入会时间：</span>
              <el-checkbox v-model="ruleDto.isCheckOpenCardTime" :disabled="isStart">指定时间段</el-checkbox>
              <div class="my_select_time" style="margin-left:8px">
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardStartTime" type="datetime"
                  placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px" class="time1"  :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||isStart">
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker prefix-icon="no_icon" v-model="ruleDto.openCardEndTime" type="datetime"
                  placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px" class="time2"
                  :picker-options="openCardEndTimeOptionsValue" :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime||isStart">
                </el-date-picker>
                <i v-if="!isStart" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
              </div>
            </div>
            <span v-if="actMember == '2'" style="color:#F56C6C">注意：该条件对【非会员】身份不生效</span>

            <span v-if="localStepNum == 3">注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span>
          </el-form-item>
          
          <el-form-item label="Plus会员身份:" required>
            <el-radio v-model="ruleDto.plusObject" :label="0" :disabled="isStart">不限</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="1" :disabled="isStart">Plus会员</el-radio>
            <el-radio v-model="ruleDto.plusObject" :label="2" :disabled="isStart">非plus会员</el-radio>
            <div style="color:#F56C6C">注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。</div>
          </el-form-item> -->

          <jd-title label='游戏规则' type="bold"></jd-title>
          <el-form-item label="赠送游戏机会:" required>
            初始赠送
            <el-input v-model="ruleForm.giveTimes" :disabled="isStart" @input.native="ruleForm.giveTimes = checkputn($event, '0')" style="width:70px" placeholder="请输入"></el-input>
            次机会
            <el-tooltip class="item" effect="light" style="color:#ccc !important" content="活动期间赠送给用户游戏次数" placement="bottom">
              <el-button type="text" style="width: 35px;">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </el-form-item>
          <template v-if="activityData.id == 24">
            <el-form-item label="游戏时间:" required>
              <el-input v-model="ruleForm.gameTime" @input.native="ruleForm.gameTime = checkputn($event, '0')" :disabled="isStart" style="width:70px" placeholder="请输入"></el-input>
              秒
            </el-form-item>

            <el-form-item label="游戏模板:" required class="zindexBox">
              <el-radio-group v-model="ruleForm.templateType" :disabled="isStart">
                <el-radio :label="0">默认全部</el-radio>
                <el-radio :label="1">指定模板</el-radio>
              </el-radio-group>
              <el-button :style="{ width: '110px', margin: ' 0 0px 0 15px' }" @click="gamePopup = true" :disabled="ruleForm.templateType == 0 || isStart">
                {{ `已选${gameTemplateList.length}个` }}
              </el-button>
              <el-tooltip class="item" effect="light" content="用户每次游戏的模板系统会随机分配，同一个用户可能会出现重复的模板" placement="bottom">
                <el-button type="text" style="width:35px">
                  <i class="el-icon-warning" style="color: #ccc;"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>
          </template>
          <template v-if="activityData.id == 23">
            <el-form-item label="容错机会:" required>
              初始赠送
              <el-input
                v-model="ruleForm.faultTimes"
                maxlength="3"
                @input.native="ruleForm.faultTimes = checkputn($event, '10')"
                style="width:70px"
                placeholder="请输入"
                :disabled="isStart"
              ></el-input>
              次机会
              <el-tooltip class="item" effect="light" style="color:#ccc !important" content="每次游戏允许用户夹不到的次数" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>
          </template>
          <div style="margin-left: 10px;margin-bottom: 10px;font-size: 16px;margin-top: 30px;">做任务得游戏机会</div>
          <el-form-item label="每日任务:">
            <jd-button v-if="isStart">添加任务</jd-button>
            <jd-button v-else @click="addCoupon(1)">添加任务</jd-button>
            <div class="rule_box" style="width:100%">
              <div class="rule_box_content" v-for="(item, i) in taskList1" :key="item.taskType">
                <div class="taskbox">
                  任务分类：{{ detailexplain(item, 1) }}
                  <div class="taskbox-content" v-if="!isStart">
                    <span style="color:#2768FF" @click="editTaskdeail(item, i, 1)">修改</span>
                    <span style="color:#2768FF" @click="changeSort(i, 0, 1)" v-if="i != 0">上移</span>
                    <span style="color:#2768FF" @click="changeSort(i, 1, 1)" v-if="i != taskList1.length - 1">下移</span>
                    <span style="color:#2768FF" @click="changedelet(i, 1)">删除</span>
                  </div>
                </div>
                <div>任务有效期：{{ item.taskValidity == 1 ? "长期有效" : `${item.startTime} ~ ${item.endTime}` }}</div>
                <div v-if="item.taskType == 3">浏览时间：{{ item.viewTime }}秒</div>
                <div v-if="item.taskType == 4">加购商品数：{{ item.addCartLimit }}个</div>
                <div v-if="item.taskType == 5">跳转链接：{{ item.jumpUrl }}</div>
                <div>任务说明：{{ detailexplain(item, 2) }}</div>
                <div v-if="item.taskType == 3 || item.taskType == 4">
                  {{ item.taskType == 3 ? "浏览" : "加购" }}商品：
                  <el-button style="width: 155px; margin: 0 15px" :class="[{'global-view-btn':backgroundOpacity}]" @click="preview(item)"> 已选择{{ item.itemList ? item.itemList.length : 0 }}个 </el-button>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="活动任务:">
            <jd-button v-if="isStart">添加任务</jd-button>
            <jd-button v-else @click="addCoupon(2)">添加任务</jd-button>
            <div class="rule_box" style="width:100%">
              <div class="rule_box_content" v-for="(item, i) in taskList2" :key="item.taskType">
                <div class="taskbox">
                  任务分类：{{ detailexplain(item, 1) }}
                  <div class="taskbox-content" v-if="!isStart">
                    <span style="color:#2768FF" @click="editTaskdeail(item, i, 2)">修改</span>
                    <span style="color:#2768FF" @click="changeSort(i, 0, 2)" v-if="i != 0">上移</span>
                    <span style="color:#2768FF" @click="changeSort(i, 1, 2)" v-if="i != taskList2.length - 1">下移</span>
                    <span style="color:#2768FF" @click="changedelet(i, 2)">删除</span>
                  </div>
                </div>
                <div>任务有效期：{{ item.taskValidity == 1 ? "长期有效" : `${item.startTime} ~ ${item.endTime}` }}</div>
                <div v-if="item.taskType == 7">开卡链接：{{ item.jumpUrl }}</div>
                <div v-if="item.taskType == 8">邀请上限人数：{{ item.inviteLimit }}个</div>
                <div>任务说明：{{ detailexplain(item, 2) }}</div>
              </div>
            </div>
          </el-form-item>
          <jd-title label='奖品设置' type="bold"></jd-title>
          <template v-if="activityData.id == 23">
            <el-form-item label="抽奖分值:" required>
              满
              <el-input
                v-model="ruleForm.scoreLimit"
                @change="handleLimit"
                @input.native="ruleForm.scoreLimit = checkputn($event, '0')"
                style="width:70px"
                placeholder="请输入"
                :disabled="isStart"
              ></el-input>
              分，可参与抽奖
              <el-tooltip class="item" effect="light" style="color:#ccc !important" content="夹中一个娃娃得分为10分" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-warning"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>
          </template>
          <el-form-item label="抽奖条件:" required v-if="activityData.id == 24">
            找出图片中的全部不同方可参与抽奖
          </el-form-item>
          <el-form-item label="中奖限制:">
            活动期间每人每天中奖不超过&nbsp;<el-input
              @input.native="ruleForm.oneDayMaxRewardNumber = checkputn($event, '0')"
              style="width:60px"
              @change="orderChange"
              v-model="ruleForm.oneDayMaxRewardNumber"
              placeholder="请输入"
              :disabled="isStart"
            ></el-input
            >&nbsp; 次，累计中奖不超过&nbsp;
            <el-input
              @input.native="ruleForm.totalMaxRewardNumber = checkputn($event, '0')"
              @change="orderChange"
              style="width:60px"
              v-model="ruleForm.totalMaxRewardNumber"
              placeholder="请输入"
              :disabled="isStart"
            ></el-input
            >&nbsp; 次，奖品有限，先到先得
          </el-form-item>
          <el-form-item required>
            <span slot="label" class="set">奖品设置:</span>
            <div class="termAdd">
              <el-popover placement="right" width="270" trigger="hover">
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/wzsyt.png" alt="" />
                <span slot="reference">位置示意图</span>
              </el-popover>
              <p>
                累计中奖率: <span class="add">{{ winningRate }} %</span>
              </p>
            </div>
            <jd-table
              :tableData="prizeSettingList"
              style="width: 100%;"
            >
              <el-table-column label="位置">
                <template slot-scope="scope">
                  <span v-if="scope.row.index == 0">一</span>
                  <span v-if="scope.row.index == 1">二</span>
                  <span v-if="scope.row.index == 2">三</span>
                  <span v-if="scope.row.index == 3">四</span>
                  <span v-if="scope.row.index == 4">五</span>
                  <span v-if="scope.row.index == 5">六</span>
                  <span v-if="scope.row.index == 6">七</span>
                  <span v-if="scope.row.index == 7">八</span>
                </template>
              </el-table-column>

              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <jd-button type="blueText" v-if="isStart">选奖品</jd-button>
                  <jd-button type="blueText" v-else @click="centerVis(scope.row)">选奖品</jd-button>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  {{ getPrizeTypeName(scope.row.prizeType) }}
                  <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">京豆</span>
                  <span v-if="scope.row.prizeType == 3">实物</span>
                  <span v-if="scope.row.prizeType == 4">店铺积分</span>
                  <span v-if="scope.row.prizeType == 5">京东E卡</span>
                  <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                  <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                  <span v-if="scope.row.prizeType == 8">现金红包</span>
                  <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                  <span v-if="scope.row.prizeType == 10">礼品卡</span>
                  <span v-if="scope.row.prizeType == 12">{{venderType? '令牌' : '专享价'}}</span>
                  <span v-if="scope.row.prizeType == 13">令牌</span> -->
                </template>
              </el-table-column>

              <el-table-column label="值" width="80" prop="price"> </el-table-column>

              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.title"
                    maxlength="12"
                    show-word-limit
                    style="width: 240px"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品总数" width="180">
                <template slot="header">
                  <span>奖品总数</span>
                  <el-popover
                    placement="top-start"
                    offset="100"
                    trigger="hover"
                    content="奖品总量是控制奖品最多发放份数，达到设置数值后不再发放此奖品；"
                  >
                    <span slot="reference">
                      <p class="question_icon">!</p>
                    </span>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.totalAmount"
                    @input="(e) => (scope.row.totalAmount = checkputn(e, scope.row, 'jindou'))"
                    placeholder="请输入..."
                    style="width: 70px"
                    @input.native="scope.row.totalAmount = checkputn($event),prizeNum(scope.row)"
                    @blur="beAdd(scope.row)"
                    :disabled="activityData.isStart && !scope.row.minNum || activityData.isStart"
                  ></el-input>
                  份
                </template>
              </el-table-column>
              <el-table-column label="每日发放限额" width="120">
                <template slot-scope="scope">
                  <dailyLimitConfig
                    :row="scope.row"
                    :backgroundOpacity="backgroundOpacity"
                    :limitBtnDisabled="backgroundOpacity"
                  ></dailyLimitConfig>
                </template>
              </el-table-column>
              <el-table-column label="中奖率" width="120px">
                <template slot="header">
                  <span>中奖率</span>
                  <el-popover
                    placement="top-start"
                    width="480"
                    offset="100"
                    trigger="hover"
                    content="中奖总概率可设置区间为0%至100%。本软件中奖概率是按数学中的概率统计学来计算的，并非硬性指标。 比如概率为1%，并非100次抽奖有且只有1次中奖，也不是第100次抽奖才会中奖。 而是每一次抽奖的机率都是平等的，第一次抽是1%,第100次、1万次抽也是1%。 举个现实中抽奖的例子，抽奖箱中有100个球，其中1个是红球代表中奖，其它99个是白球代表不中奖，每一次只能从中抽取1个球， 抽完后再放入箱中，下一个人再来抽(即每次抽奖箱中都有100个球，保证每次抽奖的概率平等性)，这样有可能第1个抽奖的就抽中了红球，或有可能第100个抽奖的都没抽中，也或100个人抽了已经有3个抽中了红球都有可能，都是属于统计学的概率问题。"
                  >
                    <span slot="reference">
                      <p class="question_icon">!</p>
                    </span>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.percentage"
                    @input="scope.row.percentage = getNumberData(1, $event, 1, 0)"
                    placeholder="请输入..."
                    style="width: 70px"
                    @keyup.native="scope.row.percentage = oninput2(scope.row.percentage)"
                    :disabled="isStart"
                  ></el-input>
                  %
                </template>
              </el-table-column>

              <el-table-column label="图片" width="170">
                <template slot="header">
                  <span>图片</span>
                  <el-popover
                    placement="top-start"
                    width="400"
                    offset="100"
                    trigger="hover"
                    content="图片显示在抽奖页面的奖品展示区域，建议图片宽高为200px*200px图片必须为jpg和png格式，小于300KB;"
                  >
                    <span slot="reference">
                      <p class="question_icon">!</p>
                    </span>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <img v-if="scope.row.logo" :src="scope.row.logo" style="width: 56px; height: 56px" />
                </template>
              </el-table-column>

              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <jd-button type="blueText" @click="cleanData(scope.row)" v-if="!isStart">清除</jd-button>
                  <jd-button type="blueText" v-if="isStart && scope.row.title"
                    @click="itemAddNum('prizeSettingList',scope.$index)">增加奖品数量</jd-button>
                </template>
              </el-table-column>
            </jd-table>
            <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
            <div style="margin-top: 16px">
              <jd-tip>
                说明<br/>
                <p>
                  1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”
                </p>
                <p>
                  2、中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
                </p>
              </jd-tip>
            </div>
          </el-form-item>
          <activityPageSettings 
            isShowShopName
            v-model="customerPaperwork"
            :isNeedCustomerPaperworkData="false"
            :giftList="activityData.id == 24 ? giftList24 : giftList"
            :templateId="activityData.id"
            :cusTemplateJSON.sync="ruleDto.cusTemplateJSON"
            :widthNumber="750"
            :heightNumber="1448"
            :isNeedSetBG="activityData.id == 23 ? true : false"
            templatekey="templateUrl"
            previewKey="templateUrl"
            :designSpecificationsUrl="designSpecificationsList[activityData.id]"
          />
          <exposureList 
            v-model="itemListFor"
            :defaultExposureSwitch.sync="ruleForm.exposureSwitch"
          />
          <!-- <jd-title label='曝光商品' type="bold"></jd-title>
          <el-form-item label="曝光商品:" class="zindexBox">
            <el-checkbox v-model="ruleForm.exposureSwitch" @change="exposureSwitchChange" :disabled="!isSave">
              是否添加曝光商品
            </el-checkbox>
            <jd-button
              :class="[{'global-view-btn':backgroundOpacity}]"
              style="margin: 0 15px;"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{ itemListFor.length != "" ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")" : "添加曝光商品" }}
            </jd-button>
            <el-radio-group v-model="ruleForm.radio" :disabled="ruleForm.exposureSwitch == false">
              <el-radio :label="0">显示京东价</el-radio>
            </el-radio-group>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px;"
              filter=".unmover"
            >
              <transition-group type="transition">
                <div v-for="(item, index) in mainImagelist" :key="item.skuId" style="display: inline-block; position: relative" class="show_upImg2">
                  <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg" @click.stop="delec(index)" class="delectIcom" />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item> -->
          <sharFrom 
            v-model="ruleForm"
            :sharePic="sharePic"
          />
          <!-- <jd-title label='分享设置' type="bold"></jd-title>
          <el-form-item label="小程序分享标题:" required label-width="125">
            <el-input
                type="text"
                style="width: 425px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.shareTitle"
                :maxlength="28"
                :disabled="isStart"
              ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享简介:" required label-width="125">
            <el-input
                type="text"
                style="width: 425px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.shareIntroduce"
                :maxlength="28"
                :disabled="isStart"
              ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享图片:" required label-width="130">
            <div class="miniAppPic" style="margin-left:16px;">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload1"
                  :on-success="handleUpload1"
                  :disabled="isStart"
                  >
                  <jd-button type="blueText">自定义上传</jd-button>
                </el-upload>
                <jd-button type="blueText" v-if="isStart" style="margin-left: 20px">重置</jd-button>
                <jd-button type="blueText" v-else @click="picUrlReset1"  style="margin-left: 20px">重置</jd-button>
              </div>
              <div class="bottom">
                <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：200px * 200px</p>
                  <p>图片大小：1MB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item> -->
          <activityRules 
            v-model="ruleForm.activityRulesText"
            :isForceRemind.sync="ruleDto.isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          />
          <!-- <jd-title label='活动规则' type="bold"></jd-title>
          <el-form-item label="规则内容:" required>
            <div
              style="
              width: 570px;backgroundcolor: rgba(250, 250, 250, 1);
              padding: 8px;
              position: relative;
            "
            >
              <el-input
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :maxlength="2000"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{ ruleForm.activityRulesText.length ? ruleForm.activityRulesText.length : 0 }}/2000）
              </div>
              <div style="margin-top: 16px">
                <jd-button type="blue"  @click="generateRule">生成规则</jd-button>
              </div>
            </div>
            <div class="rule-tip">
              <jd-tip color="gley">
                提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
              </jd-tip>
            </div>
          </el-form-item> -->

          <!-- <div v-if="backgroundOpacity" class="backgroundOpacity"></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 99">
      <jd-button v-show="!itemId && backgroundOpacity" style="margin-right: 8px" @click="clickLocalStep()">
        {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn">保存至草稿箱</jd-button>
      <template v-if="!backgroundOpacity">
        <jd-button v-show="!itemId" v-if="isSave" type="blue" @click="saveEdit" v-preventReClick
          >保存设置</jd-button
        >
      </template>
      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit">取消</jd-button>
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>
    <!-- 查看回显商品 -->
    <selectGoodsMonitor
      v-if="previewGoods"
      ref="selectGood"
      :isShow="previewGoods"
      :selectGoods="previewGoodsList"
      @close="previewGoodsClose"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :numlimit="30"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800" @close="checked = false">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取消</jd-button>
        <jd-button @click="handleDialogCloseAnoth()" type="blue" style="margin-left: 8px">确定</jd-button>
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct v-if="showSelectProduct" ref="selectProduct" :echoDate="echoDate" :actId="valueRow" :num="1" :JingdouCount="JingdouCount" :actType="activityData.id" :actEndTime="ruleForm.endTime" @choose-shop="getTheData">
    </selectProduct>
    <!-- 每日任务弹窗 -->
    <dailytask
      :timeDate="activityTimeValue"
      :ActivityIsAdd="ActivityIsAdd"
      :taskItem="taskItem"
      :disabledtask="disabledtask"
      :ActivityType="taskSeletFlay"
      v-if="dailytaskFlay"
      @handleChoice="handleChoice"
      @handleChoiceEdit="handleChoiceEdit"
    ></dailytask>

    <!-- 确定礼包模板弹窗 -->
    <game-popup :gameTemplateList="gameTemplateList" :giftList="giftList" @handleTemplate="handleTemplate" v-if="gamePopup" />
    <!-- 选择人群 -->
    <selectPeople v-if="selectPeopleShow" :dialogVisible="selectPeopleShow" :peopleList="peopleList" @confim="selectPeopleSure" @close="selectPeopleShow = false"></selectPeople>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>
  </div>
</template>

<script>
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import informationForm from "./components/informationForm.vue"
import activityPageSettings from "./components/activityPageSettings.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityRules from "./components/activityRules.vue"
import selectPeople from "@/components/select-people-yunqi.vue";
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import selectProduct from "./select_product_componentization.vue";
import QRCode from "qrcodejs2";
import { mapState } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";
import dailytask from "./Dailytask.vue";
import { editGameHub, createGameHub, getGameHub, getGameTemplate } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import gamePopup from "./gamePopup.vue";
import addPrizeNum from "./components/add-prize-num.vue";
// import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

export default {
  components: {
    selectProduct,
    selectPrize,
    // SelectGoods,
    selectGoodsMonitor,
    draggable,
    dailytask,
    gamePopup,
    selectPeople,
    addPrizeNum,
    informationForm,
    activityPageSettings,
    exposureList,
    sharFrom,
    activityRules,
    dailyLimitConfig
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    statusComment: {
      type: Boolean,
      default: false,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });

      this.winningRate = this.winningRate.toFixed(3);
    },
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
  },
  filters: {
    prizeType(num) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      }
      return result;
    },
  },
  data() {
    return {
      customerPaperwork: {},
      giftList24: [{
        id: 24,
        templateUrl: "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zc.png"
      }],
      actEndTime: "",
      isShowTip: false,
      showSelectProduct: false,
      // 1.14迭代
      ruleDto:{
        isCheckOpenCardTime:false,
        openCardStartTime:'',
        openCardEndTime:'',
        plusObject:0, //plus会员
        cusTemplateJSON: "", // 自定义背景图
        isForceRemind: false, // 是否强制提醒
      },
      isKeyActivity: 0,
      placementPosition: [],
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleDto.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf();
        },
      },

      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      echoDate: {},
      // topindex: 0,
      gameTemplateList: [],
      gamePopup: false,
      taskItem: {},
      disabledtask: [],
      edittaskIndex1: 0,
      edittaskIndex2: 0,
      ActivityIsAdd: false, // 新增 修改
      taskSeletFlay: true, // 每日活动 活动任务
      taskList1: [], //每日任务
      taskList2: [], // 活动任务
      dailytaskFlay: false,
      defaultTime: [this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length), this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.activityEndTime).valueOf()-24*60*60*1000;
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.activityStartTime).valueOf();
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      winningRate: 0,
      theNum: 0,
      index: 0,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          percentage: null,
        },
      ],
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftList: [], // 礼包模板
      levelList: [],
      disableTime: false,
      qrcode: null,
      order: "",
      //时间限制
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      previewGoods:false,
      previewGoodsList:[],
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      localStep: 0,
      localStepNum: this.activityData.id,
      ruleForm: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 0, // 开卡入会后方可参与活动
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        activityStartTime: null, //活动开始时间
        activityEndTime: null, //活动结束时间
        activityRulesText: "", //生成规则
        // 抓娃娃 找茬
        totalMaxRewardNumber: "", //活动期间最大中奖次数
        oneDayMaxRewardNumber: "", //每人每天最大中奖次数
        giveTimes: 5, //赠送游戏机会
        faultTimes: 5, //容错机会
        scoreLimit: "", //分数下限限制
        gameTime: 90, //游戏时间，单位秒
        templateType: 0, //游戏模板类型 0全部 1指定
        templateIds: "", //
        itemList: [], //曝光商品集合
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        isValidBlackList: 0,
      },
      sharePic: "",
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [{ required: true, message: "请选择活动时间", trigger: "change" }],
        activityRulesText: [{ required: true, message: "请填写活动规则", trigger: "blur" }],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        itemArr: [],
      },
      isStart: false,
      isDraft: false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,
    };
  },
  created() {
    console.log('当前玩法id',this.activityData.id);
    this.sharePic = this.getDefaultSharePic(this.activityData.id)
    this.ruleForm.sharePic = this.sharePic
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`
    // 数据初始化
    this.getPolite();
    // 修改 数据回显
    if (this.activeValue) {
      this.activityData.id = this.activeValue;
      this.getRedParker();
    } 
    // 新增活动默认时间
    if(!this.valueRow){
      this.ruleForm.activityStartTime = this.$getDate(30)[0]
      this.ruleForm.activityEndTime = this.$getDate(30)[1]
      this.activityTimeChange();
    }
    // console.log(this.valueRow.id, this.activeValue, 6666666);
  },
  mounted() {
    this.getLevel();
    this.$nextTick(() => {
      this.getCodeIMG();
      // window.addEventListener("scroll", (e) => {
      //   this.topindex = e.target.scrollingElement.scrollTop;
      // });
    });
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    this.isStart = this.activityData.isStart ? true : false
  },
  methods: {
    // 点击下单时间显示提示
    orderFocus() {
      if(this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let {toAddBelong, toAddIndex} = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr,index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount
      };
      if( !this.toAddItem.title || this.toAddItem.title=="谢谢参与" ) {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },
    // 打开选择人群
    openCrowd(){
      this.peopleList = this.peopleSelected.map(item => {
        return { id: item }
      })
      this.selectPeopleShow = true
      this.actMember = "3"
    },
    // 选择人群关闭
    selectPeopleSure(val){
      this.peopleSelected = val.map(item=>item.id)
      this.selectPeopleShow = false
    },
    // 京东计划数量计算
    prizeNum(row){
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if([5,6,7,8,10].includes(Number(row.prizeType))){
        if(Number(row.totalAmount) && (Number(row.totalAmount) > row.budgetRemain)){
          row.totalAmount = ""
          if(row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
          if(row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
          if(row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
          if(row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
          if(row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row){
      console.log(row);
      if(this.isStart){
        if(row.totalAmount < row.minNum && row.minNum){
          row.totalAmount = row.minNum
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 200 && image.height == 200)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if(valid){
        }else{
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res){
      if(res.code != 1){
        this.$message.error(res.message);
      }else{
        console.log(this.uploadSize);
        if(this.uploadSize){
          this.ruleForm.sharePic = res.data;
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1(){
      this.ruleForm.sharePic = this.sharePic
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    // 数据初始化
    async getPolite() {
      this.giftList = [
        {
          createTime: "2021-11-08 17:02:20",
          days: "",
          expirationType: 0,
          giftPrizeType: 1,
          giftType: 1,
          id: "23",
          openMerchant: "",
          openType: 0,
          templateUrl: "",
          title: "欢乐娃娃机",
          updateTime: "2021-11-12 10:19:55",
        },
      ];
      if (this.activityData.id == 23) {
        this.giftList[0].templateUrl = "https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/zww.png";
      }else {
        this.nextStepKai();
        const { data } = await getGameTemplate();
        this.giftList = data.map((item) => ({
          ...item,
          checked: false,
          days: item.templateType == 2 ? this.getDaysBetween(item.appointTimeStart, item.appointTimeEnd) : "",
        }));
      }
    },
    // 数据回显
    getRedParker() {
      getGameHub(this.valueRow.id).then((res) => {
        this.ruleForm.activityName = res.data.activityName + (this.activityData.isCopy?"复制":"");
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.isValidBlackList = res.data.isValidBlackList;
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        // 1.14迭代 这里回显
        this.ruleDto = {
          isCheckOpenCardTime:res.data.ruleDTO.isCheckOpenCardTime,
          openCardStartTime:res.data.ruleDTO.openCardStartTime,
          openCardEndTime:res.data.ruleDTO.openCardEndTime,
          plusObject:res.data.ruleDTO.plusObject, //plus会员
          cusTemplateJSON: res.data.ruleDTO.cusTemplateJSON, // 自定义背景图
          isForceRemind: res.data.ruleDTO.isForceRemind, // 是否强制提醒
        }
        this.ruleForm.firstOpenCardTimeType = res.data.ruleDTO.firstOpenCardTimeType;
        this.ruleForm.openCardBeforeDay = res.data.ruleDTO.openCardBeforeDay;
        this.ruleForm.openCardFollow = res.data.ruleDTO.openCardFollow;
        this.customerPaperwork = res.data.ruleDTO.customerPaperwork ? JSON.parse(res.data.ruleDTO.customerPaperwork) : {}
        
        this.ruleForm.activityStartTime = res.data.startTime?String(res.data.startTime):null;
        this.ruleForm.activityEndTime = res.data.endTime?String(res.data.endTime):null;
        this.actEndTime = res.data.endTime;
        this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
        this.isKeyActivity = res.data.isKeyActivity||0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
        if(res.data.allowLevel == "99"){
          this.peopleSelected = res.data.crowdIds.split(",")
          this.actMember = "3"
        }else if(res.data.allowLevel == "-1"){
          this.actMember = "1"
        }else{
          this.actMember = "2"
            if (res.data.allowLevel.indexOf('-1') != -1) {
              this.ruleForm.partner = ['-1']
            }
        }

        // 分享设置
        this.ruleForm.shareTitle = res.data.ruleDTO.shareTitle;
        this.ruleForm.shareIntroduce = res.data.ruleDTO.shareIntroduce;
        this.ruleForm.sharePic = res.data.ruleDTO.sharePic;

        this.ruleForm.giveTimes = res.data.ruleDTO.giveTimes;
        if (this.activityData.id == 23) {
          this.ruleForm.faultTimes = res.data.ruleDTO.faultTimes;
          if(!this.activityData.isCopy) this.ruleForm.scoreLimit = res.data.ruleDTO.scoreLimit;
        }
        if (this.activityData.id == 24) {
          this.ruleForm.gameTime = res.data.ruleDTO.gameTime;
          this.ruleForm.templateType = res.data.ruleDTO.templateType;
          this.gameTemplateList = res.data.ruleDTO.templateType == 1 ? res.data.gameTemplateId.split(",") : [];
          if (res.data.ruleDTO.templateType == 1 && this.backgroundOpacity) {
            this.giftList = res.data.gameTemplateList.map((item) => ({
              ...item,
              checked: false,
            }));
          }
        }
        this.taskList1 = res.data.taskList.filter((val) => val.activityType == 1);
        this.taskList2 = res.data.taskList.filter((val) => val.activityType == 2);
        if(!this.activityData.isCopy){
          // 奖品
          this.prizeSettingList = res.data.integralParadisePrizeDTOS.map((item) => {
            // 提交地址限制回显：逗号分隔字符串转数字数组
            if (item.prizeType == 3) {
              if (item.commitAddressLimit) {
                item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                  ? item.commitAddressLimit.split(',').map(Number)
                  : item.commitAddressLimit;
              } else {
                item.commitAddressLimit = [0];
              }
            }
            return item;
          });
          this.prizeSettingList.forEach((item, index) => {
            item.index = index;
            item.minNum = item.totalAmount
            if (item.percentage) {
              this.winningRate += Number(item.percentage);
            }
          });
          this.winningRate = this.winningRate.toFixed(3);
          this.ruleForm.oneDayMaxRewardNumber = res.data.ruleDTO.oneDayMaxRewardNumber;
          this.ruleForm.totalMaxRewardNumber = res.data.ruleDTO.totalMaxRewardNumber;
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          //曝光商品
          this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
          this.selectGoodsArr = res.data.itemList;
          this.mainImagelist = res.data.itemList;
          this.itemListFor = res.data.itemList;
        }
        this.activityTimeChange();
      });
    },
    //清除
    cleanData(row) {
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
      row.shouldCollectExtraData = 0
      row.extraQuestion = null
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(3);
      }
    },
    // 获取奖品
    getTheData(data, prizeType) {
      if (this.venderType && prizeType == 1 && data.couponType == 1) {
        return this.$message.warning("此类型奖品暂时不支持自营店铺！");
      }
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
        this.prizeSettingList[this.index].singleAmount = 1;
        this.prizeSettingList[this.index].quota = data.quota;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if(!data.isGoodManage) {
          this.prizeSettingList[this.index].skuId = data.skuId;
          delete this.prizeSettingList[this.index].isGoodManage
        } else {
          this.prizeSettingList[this.index].isGoodManage = data.isGoodManage;
        }
        this.prizeSettingList[this.index].isFollowActivityEndTime = data.isFollowActivityEndTime;
        this.prizeSettingList[this.index].addressFillEndTime = data.addressFillEndTime;
        this.prizeSettingList[this.index].predictSendTime = data.predictSendTime;
        this.prizeSettingList[this.index].shouldCollectExtraData = data.shouldCollectExtraData; //是否需要额外信息
        this.prizeSettingList[this.index].extraQuestion = data.extraQuestion; //额外问题
        this.prizeSettingList[this.index].addressFillLimit = data.addressFillLimit;
        this.prizeSettingList[this.index].commitAddressLimit = data.commitAddressLimit;
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.index].price = data.discount || data.singleAmount;

      this.prizeSettingList[this.index].assetsId = Number(data.couponId || data.skuId);
      this.prizeSettingList[this.index].logo = data.logo;
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = data.discount + "店铺积分";
      } else {
        this.prizeSettingList[this.index].title = data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.prizeSettingList[this.index],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if([2,5,6,7,8,10].includes(Number(prizeType))){
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      this.showSelectProduct = false
      console.log(this.prizeSettingList, 123);
    },
    // 保留小数点后两位
    oninput2(val) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
    },
    //选择奖品弹窗
    centerVis(row) {
      this.itemArr = this.prizeSettingList
      this.JingdouCount.prizeCount = row.totalAmount;
      this.echoDate = row;
      this.index = row.index;
      this.showSelectProduct = true
      this.$nextTick(()=>{
        this.$refs.selectProduct.openDialog();
      })
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      const url = `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=${this.activityData.id}`;
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url,
        });
      }
    },
    // 裂变  添加优惠券
    addCoupon(type) {
      this.activityTimeValue = [this.ruleForm.activityStartTime,this.ruleForm.activityEndTime]
      if (type == 1) {
        this.disabledtask = this.taskList1.map((val) => {
          return val.taskType;
        });
        if (this.taskList1.length == 5) {
          return this.$message.warning("每日任务全部类型已创建完成,请修改任务");
        }
      } else {
        this.disabledtask = this.taskList2.map((val) => {
          return val.taskType;
        });
        if (this.taskList2.length == 3) {
          return this.$message.warning("活动任务全部类型已创建完成,请修改任务");
        }
      }
      this.dailytaskFlay = true;
      this.ActivityIsAdd = false;
      // type == 1为每日任务
      this.taskSeletFlay = type == 1 ? true : false;
      console.log(this.disabledtask, 66666);
    },
    //模板下一步
    nextStepKai(items) {
      // console.log(items);
      //新增判断
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      // daysStart = this.ruleForm.activityStartTime && this.ruleForm.activityStartTime.substring(0, 10);
      // daysEnd = this.ruleForm.activityEndTime && this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        // datas = daysEnd.split("-");
        // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // datas = daysStart.split("-");
        // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        // this.timeDay = days;

        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(Math.abs(new Date(this.ruleForm.activityEndTime)-new Date(this.ruleForm.activityStartTime)) / 1000 / 60 / 60 / 24);

        //计算小时
        date3 = new Date(this.ruleForm.activityEndTime).getTime() - new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }
      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        this.ruleForm.activityEndTime = "";
        return;
      }
      const day = 86400000 * 60;
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },
    // 抽奖判断
    orderChange() {
      if (
        Number(this.ruleForm.oneDayMaxRewardNumber) > Number(this.ruleForm.totalMaxRewardNumber) &&
        this.ruleForm.totalMaxRewardNumber &&
        this.ruleForm.oneDayMaxRewardNumber
      ) {
        this.ruleForm.totalMaxRewardNumber = "";
        this.$message.warning("活动期间每人每天中奖次数不能大于累计中奖次数");
      }
    },
    // 返回上一步
    returnBack() {
      // this.$emit("returnBack");
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.activityData.id == 23) {
        if (this.localStep == 0) this.$emit("returnBack");
        if (this.localStep == 1) this.localStep = 0;
      } else {
        this.$emit("returnBack");
      }
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      // 公活动配置校验
      // if (!useValidateMoreActSet(this)) {
      //   return;
      // }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      // 评价
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        activityType: this.activityData.id, //活动类型 23:疯狂捉娃娃 24:大家来找茬
        // condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示京东价 1：显示促销
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        itemList: this.itemListFor, //曝光商品集合
        integralParadisePrizeDTOS: [], //抽奖奖项设置
        // 1.14迭代 这里提交
        ruleDTO: {
          firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType, // 首次入会时间类型
          openCardBeforeDay: this.ruleForm.openCardBeforeDay, // 参与活动前N天
          openCardFollow: this.ruleForm.openCardFollow, // 开卡入会后方可参与活动
          isCheckOpenCardTime:this.actMember==2?this.ruleDto.isCheckOpenCardTime:false,
          openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
          openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
          plusObject:this.ruleDto.plusObject, //plus会员
          cusTemplateJSON: this.ruleDto.cusTemplateJSON, // 自定义背景图
          isForceRemind: this.ruleDto.isForceRemind, // 是否强制提醒

          totalMaxRewardNumber: this.ruleForm.totalMaxRewardNumber,
          oneDayMaxRewardNumber: this.ruleForm.oneDayMaxRewardNumber,
          giveTimes: this.ruleForm.giveTimes,
          faultTimes: this.ruleForm.faultTimes,
          scoreLimit: this.ruleForm.scoreLimit,
          gameTime: this.ruleForm.gameTime,
          templateType: this.ruleForm.templateType,
          templateIds: this.gameTemplateList.join(","),
          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,
          customerPaperwork: JSON.stringify(this.customerPaperwork),
        },
        taskList: [...this.taskList1, ...this.taskList2],
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        isValidBlackList: this.ruleForm.isValidBlackList, // 是否开启黑名单
        studentStatus: this.ruleForm.studentStatus,
      };
      if(this.actMember == 1){
        cardParams.allowLevel = "-1"
      }else if(this.actMember == 3){
        cardParams.allowLevel = "99"
        cardParams.crowdIds = this.peopleSelected.join(",")
      }else if(this.actMember == 2){
        cardParams.allowLevel = this.ruleForm.partner.join(",")
        if (cardParams.allowLevel == '-1') {
          //会员等级设置
          let list = ['-1','0']
          this.levelList.forEach((item,index) => {
            let num = index + 1
            list.push(num)
          })
          cardParams.allowLevel = list.join(",")
        }
      }
      cardParams.integralParadisePrizeDTOS = this.prizeSettingList.map((item) => {
        let prize = {
          ...item,
          percentage: item.percentage ? item.percentage : 0,
        };
        if (prize.prizeType == 1) {
          prize.quota = item.quota;
          prize.couponType = item.couponType;
          prize.singleAmount = 1;
        } else if (prize.prizeType == 2 || prize.prizeType == 4) {
          prize.singleAmount = item.price;
        } else if (prize.prizeType == 3) {
          prize.assetsId = item.skuId || item.assetsId;
          // 提交地址限制：数组转逗号分隔字符串
          if (Array.isArray(prize.commitAddressLimit)) {
            prize.commitAddressLimit = prize.commitAddressLimit.join(',');
          }
        } else {
          prize.singleAmount = 1;
        }

        return prize;
      });
      // console.log(cardParams);
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            // if (obj.wareId == a[i]) {
            //   b.push({
            //     logo: obj.logo,
            //     price: obj.price,
            //     title: obj.title,
            //     wareId: obj.wareId,
            //   });
            // }
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
              });
            }
          });
        }
        cardParams.itemList = b;
      }
      if(!this.isDraft){
        //活动名称的限制
        if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
          this.$message.warning("请输入活动名称");
          return;
        }
        //活动时间的限制
        if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
          this.$message.warning("请输入活动时间");
          return;
        }
        let nowTime = new Date().getTime();
        let end = new Date(this.ruleForm.activityEndTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return
        }
        if (!this.ruleForm.partner.length) {
          this.$message.warning("请选择活动对象");
          return;
        }

        // 1.14迭代 这里判断
        // if(this.actMember == '2'){
        //   if(this.ruleDto.isCheckOpenCardTime&&(!this.ruleDto.openCardStartTime||!this.ruleDto.openCardEndTime)){
        //     return this.$message.warning("请选择入会时间");
        //   }
        // }
        if (this.actMember == "2") {
          if (
            this.ruleForm.firstOpenCardTimeType == 1 &&
            (!this.ruleForm.openCardBeforeDay)
          ) {
            return this.$message.warning("请完善首次入会时间");
          }
          if (
            this.ruleForm.firstOpenCardTimeType == 2 &&
            (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
          ) {
            return this.$message.warning("请完善首次入会时间");
          }
        }
        if (this.actMember == 3 && !this.peopleSelected.length){
          this.$message.warning("请选择指定人群");
          return;
        }
        let taskListArr = [...this.taskList1, ...this.taskList2];
        if (taskListArr.length != 0) {
          let taskIsflay = false;
          let activityStartTime = new Date(this.ruleForm.activityStartTime.substring(0, 10)).valueOf();
          let activityEndTime = new Date(this.ruleForm.activityEndTime.substring(0, 10)).valueOf();
          taskListArr.forEach((item) => {
            if (item.startTime) {
              let startTime = new Date(item.startTime.substring(0, 10)).valueOf();
              let endTime = new Date(item.endTime.substring(0, 10)).valueOf();
              if (startTime < activityStartTime || endTime > activityEndTime) {
                taskIsflay = true;
              }
            }
          });
          if (taskIsflay) return this.$message.warning(`任务有效期超出了活动时间范围，请重新选择`);
        }
        //请输入赠送游戏机会
        if (!this.ruleForm.giveTimes) {
          return this.$message.warning("请输入赠送游戏机会");
        }
        // 娃娃
        if (this.activityData.id == 23) {
          //请输入容错机会
          if (!this.ruleForm.faultTimes) {
            return this.$message.warning("请输入容错机会");
          }
          //请输入抽奖分值
          if (!this.ruleForm.scoreLimit) {
            return this.$message.warning("请输入抽奖分值");
          }
        }
        // 找茬
        if (this.activityData.id == 24) {
          cardParams.gameTemplateId =
            this.ruleForm.templateType == "0" ? this.giftList.map((item) => item.id).join(",") : this.gameTemplateList.join(",");

          //请输入游戏时间
          if (!this.ruleForm.gameTime) {
            return this.$message.warning("请输入游戏时间");
          }
          if (this.ruleForm.templateType == 1 && this.gameTemplateList.length == 0) {
            return this.$message.warning("请输入选择游戏模板");
          }
        }

        // // 请将奖品填写完整！
        let isFlay = false;
        this.prizeSettingList.forEach((item) => {
          if (item.prizeType != 9) {
            if (!item.prizeType || item.percentage === "" || !item.totalAmount || !item.title) {
              isFlay = true;
            }
          }
        });

        if (isFlay) {
          return this.$message.warning("请将奖品填写完整！");
        }
        //请添加曝光商品！
        if (this.ruleForm.exposureSwitch) {
          if (this.itemListFor.length === 0) {
            this.$message.warning("请添加曝光商品！");
            return;
          }
        }
        // 小程序分享标题
        if (!this.ruleForm.shareTitle) {
          this.$message.warning("请输入小程序分享标题");
          return;
        }
        // 小程序分享简介
        if (!this.ruleForm.shareIntroduce) {
          this.$message.warning("请输入小程序分享简介");
          return;
        }
        //活动规则不能为空
        if (!this.ruleForm.activityRulesText) {
          this.$message.warning("活动规则不能为空");
          return;
        }
        if(this.placementPosition.length==0) {    
          this.$message.warning("请选择活动投放位置！");
          return
        }
      }
      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        if (this.valueRow && !this.activityData.isCopy && !this.isDraft && !this.isDraftEdit) {
          let res;
          if(this.activityData.isStart){ // 进行中修改 使用通用接口
            let params = {
              activityId: this.valueRow.id,
              // endTime: cardParams.endTime,
              ruleDescription: cardParams.ruleDescription,
              prizes: cardParams.integralParadisePrizeDTOS.filter(item=>item.totalAmount).map(item=>{
                return {
                  ...item,
                  prizeId: item.id,
                  totalAmount: item.totalAmount,
                  title:item.title
                }
              }),
              isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
              itemList: this.itemListFor,
              ruleDTO: {
                isCheckOpenCardTime:this.actMember==2?this.ruleDto.isCheckOpenCardTime:false,
                openCardStartTime:this.actMember==2?this.ruleDto.openCardStartTime:'',
                openCardEndTime:this.actMember==2?this.ruleDto.openCardEndTime:'',
                plusObject:this.ruleDto.plusObject, //plus会员
                cusTemplateJSON: this.ruleDto.cusTemplateJSON, // 自定义背景图
                isForceRemind: this.ruleDto.isForceRemind, // 是否强制提醒

                totalMaxRewardNumber: this.ruleForm.totalMaxRewardNumber,
                oneDayMaxRewardNumber: this.ruleForm.oneDayMaxRewardNumber,
                giveTimes: this.ruleForm.giveTimes,
                faultTimes: this.ruleForm.faultTimes,
                scoreLimit: this.ruleForm.scoreLimit,
                gameTime: this.ruleForm.gameTime,
                templateType: this.ruleForm.templateType,
                templateIds: this.gameTemplateList.join(","),
                shareTitle: this.ruleForm.shareTitle,
                shareIntroduce: this.ruleForm.shareIntroduce,
                sharePic: this.ruleForm.sharePic,
                customerPaperwork: JSON.stringify(this.customerPaperwork),
              },
              isKeyActivity: this.isKeyActivity,  
              placementPosition: this.placementPosition.join(","),
              isValidBlackList: this.ruleForm.isValidBlackList,
            }
            if(this.actEndTime!=this.ruleForm.activityEndTime) {
              params.endTime = this.ruleForm.activityEndTime
            }
            res = await updateCommon(params)
          }else{
            res = await editGameHub({ ...cardParams, id: this.valueRow.id })
          }
          if (res.code == 1) {
            this.$message.success(res.message);
            this.$router.push({
              name: "throw",
              query: {
                id: res.data.id,
                activityType: res.data.activityType,
              },
            });
          } else {
            this.$message.error(res.message);
          }
        } else {
          let newcardParams = {
            ...cardParams,
            integralParadisePrizeDTOS:cardParams.integralParadisePrizeDTOS.map(item=>{
              let price =  item.price !== null ? item.price + '' : item.price
              if(price !== null){
                price = price.replace('元','')
              }
              return {...item,price}
            })
          }
          if(this.isDraft){
            newcardParams.status = 5
          }
          // 草稿箱编辑-添加活动id
          if(this.isDraftEdit){
            newcardParams.id = this.valueRow.id
          }
          if(this.activityData.isCopy){
            delete newcardParams.id
          }
          createGameHub(newcardParams).then((res) => {
            if (res.code == 1) {
              if(this.isDraft){
                this.$message.success("保存成功！")
                this.$emit("returnBack",true);
              }else{
                this.$message.success(res.message);
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
              }
            } else {
              this.$message.error(res.message);
            }
          });
        }

        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let text1 = "",
        text2 = "",
        text3 = `\n1.游戏机会： 首次赠送游戏次数${this.ruleForm.giveTimes || 0}次；完成相应任务可获得游戏次数；`,
        text4 = `\n2.抽奖规则： 每个娃娃为10分，活动期间单次超过${this.ruleForm.scoreLimit || 0}分，参与抽奖；`,
        text5 = "\n3.助力好友：一名好友活动期间仅可为1名好友助力；",
        text6 = "\n4.奖品数量有限，先到先得；",
        text7 = "\n5.若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）；";
      const {firstTextStr,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember,false);
      let secondTextStr = "\n二、【如何参与】";
      let thirdTextStr = `\n\n三、【注意事项】\n1.${ precautions }`;
      if (this.activityData.id == 24) {
        text3 = `\n1.游戏机会： 首次赠送游戏次数${this.ruleForm.giveTimes || 0}次；完成相应任务可获得游戏次数；`;
        text4 = `\n2.抽奖规则： 在规定的${this.ruleForm.gameTime}秒时间内找出图片中所有的不同之处，即完成通关，可参与抽奖；`;
        text5 = "\n3.助力好友：一名好友活动期间仅可为1名好友助力；";
        text6 = "\n4.奖品数量有限，先到先得；";
        text7 = "\n5.若用户存在刷奖等恶意行为，一经发现将取消抽奖资格（如奖品已经发放，有权追回奖品）；";
      }
      secondTextStr += text3 + text4 + text5 + text6 + text7;
      this.ruleForm.activityRulesText = firstTextStr + secondTextStr + thirdTextStr;
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    selectGoodsClose(data) {
      if (data) {
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    detailexplain(val, type) {
      if (type == 1) {
        let arr = ["", "每日打卡", "浏览店铺", "浏览商品", "加购商品", "浏览会场", "关注店铺", "开卡入会", "好友助力"];
        return arr[val.taskType];
      } else {
        let content = "";
        if (val.taskType != 8) {
          content =
            val.taskType === 1
              ? "点击打卡"
              : val.taskType === 2
              ? "浏览店铺"
              : val.taskType === 3
              ? `浏览商品${val.viewTime}秒`
              : val.taskType === 4
              ? `加购商品${val.addCartLimit}个`
              : val.taskType === 5
              ? "浏览会场"
              : val.taskType === 6
              ? "点击关注"
              : "成功开卡";
          return content + ",赠送1次游戏机会";
        } else {
          return `每邀请1位好友，赠送1次游戏机会，最多可邀请${val.inviteLimit}位助力`;
        }
      }
    },
    // 10的倍数
    handleLimit() {
      let res = Number(this.ruleForm.scoreLimit);
      if (res % 10 != 0) {
        this.ruleForm.scoreLimit = "";
        return this.$message.warning("请填写10的N倍的正整数");
      }
    },
    //输入框限制负数
    checkputn(e, num = "-1", type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (num == "0") {
          if (e.target.value < 1) {
            e.target.value = "";
          }
        }
        if (num == "10") {
          if (e.target.value < 1 || e.target.value > 9) {
            e.target.value = "";
          }
        }
        return e.target.value
      } else {
        if (num.quantityTotal && num.price && num.totalAmount && num.prizeType == 2) {
          let numTotal = this.$jingdouTotal({ ...num, prizeCount: num.totalAmount });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return num.totalAmount;
        }
      }
    },

    //输入正数、一个小数点
    checkputnPositive(e) {
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "");
      let filtered = e.target.value;
      if (Number(filtered) < 1) {
        e.target.value = "";
      }
    },
    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    // 修改
    editTaskdeail(item, i, type) {
      this.taskItem = Object.assign({}, item);
      if (type == 1) {
        this.edittaskIndex1 = i;
        this.disabledtask = this.taskList1
          .filter((val) => val.taskType != item.taskType)
          .map((ele) => {
            return ele.taskType;
          });
        // this.disabledtask = this.taskList1.map((val) => {
        //   if (val.taskType != item.taskType) {
        //     return val.taskType;
        //   }
        // });
      } else {
        this.edittaskIndex2 = i;
        this.disabledtask = this.taskList2
          .filter((val) => val.taskType != item.taskType)
          .map((ele) => {
            return ele.taskType;
          });
      }
      this.taskSeletFlay = type == 1 ? true : false;
      this.ActivityIsAdd = true;
      this.dailytaskFlay = true;
      console.log(this.disabledtask);
    },
    // 上移下移
    changeSort(index, type, i) {
      // index 为下标 上移 type 为 0， 下移为 1.  i==1为taskList1 2为taskList2
      if (i == 1) {
        this.taskList1.splice(
          type ? index : index - 1,
          1,
          ...this.taskList1.splice(type ? index + 1 : index, 1, this.taskList1[type ? index : index - 1])
        );
      } else {
        this.taskList2.splice(
          type ? index : index - 1,
          1,
          ...this.taskList2.splice(type ? index + 1 : index, 1, this.taskList2[type ? index : index - 1])
        );
      }
    },
    changedelet(i, type) {
      if (type == 1) {
        this.taskList1.splice(i, 1);
      } else {
        this.taskList2.splice(i, 1);
      }
    },
    // 每日任务  活动 新增
    handleChoice(val) {
      console.log(val, 3333333);
      if (val) {
        let isflay = false;
        if (val.taskType > 5) {
          this.taskList2.forEach((item) => {
            if (item.taskType === val.taskType) {
              isflay = true;
            }
          });
          if (isflay) return this.$message.warning("您已创建该类型任务，请重新选择~");
          this.taskList2.push(val);
        } else {
          this.taskList1.forEach((item) => {
            if (item.taskType === val.taskType) {
              isflay = true;
            }
          });
          if (isflay) return this.$message.warning("您已创建该类型任务，请重新选择~");
          this.taskList1.push(val);
        }
      }
      this.dailytaskFlay = false;
    },
    // 每日任务  活动 修改
    handleChoiceEdit(val) {
      console.log(val, 3333333);
      if (val) {
        if (val.taskType > 5) {
          this.taskList2.splice(this.edittaskIndex2, 1, val);
        } else {
          this.taskList1.splice(this.edittaskIndex1, 1, val);
        }
        this.dailytaskFlay = false;
      }
    },
    // 指定模板
    handleTemplate(val) {
      // console.log(val);
      if (val) {
        this.gameTemplateList = val.map((item) => item.id);
      }
      this.gamePopup = false;
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if(this.activityData.isCopy) return this.localStep = 0;
      if (this.activityData.id == 24) {
        this.$emit("returnBack");
      } else {
        this.localStep = 0;
        this.localStepNum = 0;
      }
      this.ruleForm.radio = 0;
      this.ruleForm.exposureSwitch = false;
      this.itemListFor = [];
      this.ruleForm.activityName = "";
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
      this.ruleForm.condFollow = false; // 是否需要关注店铺
      this.ruleForm.filterType = "0"; //过滤商品：0全部商品 1指定商品 2排除商品
      this.mainImagelist = []; //图片拖拽排序
      this.isDragging = false;
      this.itemListFor = []; //商品弹框选择商品数据
      this.selectGoodsState = false; //曝光商品弹窗
      this.ruleForm.activityRulesText = "";
      this.$emit("titopName", this.activityData.name, false);
    },
    handleCreate() {
      window.open("https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch", "_self");
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    // 查看商品
    preview(row){
      if(!this.backgroundOpacity)return
      this.previewGoods = true
      this.previewGoodsList = JSON.parse(JSON.stringify(row.itemList))
    },
    // 关闭查看商品弹窗
    previewGoodsClose(){
      this.previewGoods = false
    }
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox){
  margin: 16px 0;
}
/deep/.el-checkbox__label {
  color: #000;
}
.taskbox {
  display: flex;
  justify-content: space-between;
  &-content {
    display: flex;
    span {
      cursor: pointer;
      padding: 0 5px;
      margin-right: 4px;
    }
  }
}

.inputcount {
  /deep/.el-input__count {
    display: none !important;
  }
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

.termAdd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  color: #333;
  p {
    margin: 0;
  }
  .add {
    margin-left: 4px;
    color: #fe4d45;
  }
}
.s {
  color: #fe4d45;
  cursor: pointer;
}
.tips {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  box-sizing: border-box;
  padding: 13px 30px;
  background: #fffaee;
  font-size: 13px;
  color: #333;
  img {
    display: inline-block;
    float: left;
    position: absolute;
    width: 14px;
    height: 14px;
    color: #ffffff;
    margin: 9px 4px 0 3px;
  }
  i {
    color: #fe8f8a;
    opacity: 0.7;
  }
  p {
    margin: 0;
    line-height: 20px;
    padding-left: 18px;
  }
}
.set {
  display: inline-block;
  margin-top: 30px;
}
.overHiddle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,
  &:focus {
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #fe4d45;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
//
// .wrapperBg {
//   background-color: #666 !important;
// }
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #cccccc;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: normal;
  margin-left: 6px;
  &:hover {
    border: 1px solid #fe4d45;
    color: #fe4d45;
  }
}
.rule_box {
  width: 860px;
  // height: 217px;
  margin-top: 9px;
  // background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;

  // &_middle {

  // }
  &_content {
    padding: 10px 15px 10px 25px;
    background: #f8f9ff;
    margin: 10px 0;
    // padding-top: 10px;
    img {
      display: inline-block;
      float: left;
      position: absolute;
      width: 14px;
      height: 14px;
      color: #ffffff;
      margin: 9px 4px 0 3px;
    }
    p {
      padding-left: 21px;
    }
  }
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #fe4d45;
    color: #fe4d45;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #fe4d45;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    // width: 60px;
    background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 55px;
  right: 30px;
}
.desc {
  i {
    opacity: 0.7;
    color: #fe4d45;
  }
  color: #999;
}
.flex {
  display: flex;
  align-items: center;
}

.add_btn1 {
  cursor: pointer;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(254, 77, 69, 0.1);
  border-radius: 4px;
  margin-top: 8px;
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  // margin: 11px 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 0px 35px 0;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #fe4d45;
                border-bottom: 1px solid #fe4d45;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #fe4d45;
                border-left: 1px solid #fe4d45;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              // font-family: system-ui;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url('https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/yhq.png');
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          // font-family: DIN;
          font-family: PingFang SC;
          font-weight: bold;
          color: #fe4d45;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .rule-tip {
      width: 540px;
      margin-left: 7px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }

  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
.miniAppPic{
  position: relative;
  .image-slot{
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i{
      font-size: 30px;
      color: #909399;
    }
  }
  .top{
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn{
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color:#fe4d45;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid #fe4d45;
      &:hover{
        color: #fff;
        background: #fe4d45;
      }
    }
    .reset{
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom{
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg{
      width: 120px; 
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1{
      position: absolute;
      left: 135px;
      top: 22px;
      line-height:2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
</style>

<style lang="scss">
:deep(.titleBox){
  margin: 16px 0;
}
// .el-popover {
//   max-width: 480px;
// }
.createPlayStep {
  .textareabox {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}
</style>
